import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  SUPPORT_CENTER_FEATURE_KEY,
  SupportCenterState,
} from './support-center.reducer';

// Lookup the 'SupportCenter' feature state managed by NgRx
export const getSupportCenterState = createFeatureSelector<SupportCenterState>(
  SUPPORT_CENTER_FEATURE_KEY
);

export const getFolders = createSelector(
  getSupportCenterState,
  (state: SupportCenterState) => state.folders
);

export const getFoldersLoaded = createSelector(
  getSupportCenterState,
  (state: SupportCenterState) => state.foldersLoaded
);

export const getFiles = (path: string) =>
  createSelector(getSupportCenterState, (state: SupportCenterState) =>
    state.files?.get(path)
  );

export const getFilesLoaded = (path: string) =>
  createSelector(getSupportCenterState, (state: SupportCenterState) =>
    state.filesLoaded?.get(path)
  );

export const getFilesList = (path: string) =>
  createSelector(getSupportCenterState, (state: SupportCenterState) =>
    state.filesLists?.get(path)
  );

export const getFilesListLoaded = (path: string) =>
  createSelector(getSupportCenterState, (state: SupportCenterState) =>
    state.filesListsLoaded?.get(path)
  );
